/**
 * Firestore answers a query it cannot send (no connection) from its local
 * cache instead of failing, so an offline list looks like an empty one and
 * the page shows its first-run panel. This app does not enable persistence,
 * so an EMPTY answer from the cache means the server was not reached: treat
 * it as the offline error a single-document read would have thrown.
 * Returns the snapshot unchanged otherwise.
 */
export function requireServerAnswer(snap) {
  if (snap && snap.empty && snap.metadata && snap.metadata.fromCache) {
    const err = new Error('Firestore query answered from cache: offline');
    err.code = 'unavailable';
    throw err;
  }
  return snap;
}
